<div class="modal-header">
    <h4 class="modal-title">Credit</h4>
</div>
<div class="modal-body">
    <dx-form [formData]="paymentCredit" validationGroup="mainValidationGroup">
        <dxi-item
            dataField="paymentCreditTypeId"
            [label]="{ text: 'Type' }"
            editorType="dxSelectBox"
            [editorOptions]="{ items: paymentCreditTypes, displayExpr: 'name', valueExpr: 'id' }"
        >
            <dxi-validation-rule type="required"> </dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="created" [label]="{ text: 'Date' }" editorType="dxDateBox">
            <dxi-validation-rule type="required"> </dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="creditAmount" [label]="{ text: 'Amount' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-validation-rule type="required"> </dxi-validation-rule>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-light" (click)="close()">Cancel</button>
</div>
